// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__13Czh","col":"Table_col__3W1tr","fulfillmentStatus":"Table_fulfillmentStatus__3b6wD","emailCol":"Table_emailCol__37vX0"};